import React from 'react';
import { Box, Card, CardContent, Typography, Chip } from '@mui/material';
import { Visibility } from '@mui/icons-material';

export default function AstroEventCard({ event, onClick, past }) {
  const daysUntil = Math.ceil((event.date - new Date()) / (1000 * 60 * 60 * 24));

  return (
    <Card onClick={onClick} sx={{
      cursor: 'pointer', height: '100%',
      border: `1px solid ${past ? 'rgba(84,84,84,0.3)' : event.color + '33'}`,
      opacity: past ? 0.65 : 1,
      transition: 'all 0.2s',
      '&:hover': {
        transform: 'translateY(-3px)',
        border: `1px solid ${event.color}88`,
        boxShadow: `0 8px 24px ${event.color}22`,
      },
      position: 'relative', overflow: 'hidden',
      '&::before': {
        content: '""', position: 'absolute',
        top: 0, left: 0, right: 0, height: 3,
        bgcolor: event.color,
      },
    }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1.5 }}>
          <Typography sx={{ fontSize: 28 }}>{event.icon}</Typography>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 700, color: event.color, lineHeight: 1.3 }}>
              {event.title}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {event.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
            </Typography>
          </Box>
        </Box>

        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.6, display: 'block', mb: 1.5 }}>
          {event.description.slice(0, 90)}...
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Visibility sx={{ fontSize: 12, color: 'text.secondary' }} />
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 10 }}>
              {event.visibility}
            </Typography>
          </Box>
          {!past && daysUntil > 0 && (
            <Chip label={`${daysUntil}d away`} size="small"
              sx={{ bgcolor: `${event.color}22`, color: event.color,
                fontSize: 9, height: 18, fontWeight: 700 }} />
          )}
          {!past && daysUntil <= 0 && daysUntil > -1 && (
            <Chip label="TODAY!" size="small"
              sx={{ bgcolor: 'rgba(102,187,106,0.2)', color: '#66bb6a',
                fontSize: 9, height: 18, fontWeight: 800 }} />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}